'use client';

import { FormMultiSelect } from '@/components/form/form-multi-select';
import { FormSelect } from '@/components/form/form-select';
import useMultidietSetupStore from '@/features/multidiet-picker/store/multidiet-picker.store';
import { MultidietPickerFormType } from '@/features/multidiet-picker/types/multidiet-picker-form.type';
import { useTranslations } from 'next-intl';
import React, { SetStateAction, useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

export const MultidietPickerFormMobile = ({
  layout,
  form,
}: {
  layout: 'page' | 'popup';
  form: UseFormReturn<MultidietPickerFormType>;
}) => {
  const t = useTranslations();
  const { multidietSetup } = useMultidietSetupStore();

  const handleEdit = () => {
    form.trigger();
  };

  if (!multidietSetup) return null;

  return (
    <div className='flex flex-col lg:flex-row gap-2 md:gap-5 items-stretch justify-center w-full px-4 lg:px-0 min-w-0 max-w-full'>
      {multidietSetup && (
        <FormMultiSelect
          form={form}
          fieldName='dietTypeMobile'
          fieldOptions={multidietSetup.dietTypes.map((tag) => ({
            label: t(`dietTags.${tag.dietTag}`),
            value: tag.dietTag,
          }))}
          layout='big'
          onSaveCb={handleEdit}
          onResetCb={handleEdit}
          className=' flex-1 min-w-0 '
        />
      )}
      {multidietSetup && (
        <FormSelect
          className='flex-1 min-w-0  '
          form={form}
          clearable={false}
          fieldName='calories'
          layout='big'
          fieldOptions={multidietSetup.calories.map((calory) => ({
            label: <span>{t('common.kcal', { kcal: calory })}</span>,
            value: calory.toString(),
          }))}
          onChange={handleEdit}
        />
      )}
    </div>
  );
};
